module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e09-ae26bee95a05560451ccdfec108ed2a1.jpg";